module.exports = __webpack_public_path__ + "static/media/DREAMLogoType.a31cc40f.png";